import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import ProductBlock from '../../ProductBlock/components/ProductBlock.js';
import { getZeroDiscount } from '../utils/get-zero-discount.js';
import { convertProductRecommendationInfo } from '../utils/mappers.js';

var ProductRecommendation = /*#__PURE__*/ React__default.forwardRef((_param, ref)=>{
    var { recommendation , formatProductUrl , locale  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "recommendation",
        "formatProductUrl",
        "locale"
    ]);
    const info = convertProductRecommendationInfo(recommendation, formatProductUrl, locale);
    if (!info) return null;
    const { sku , tags  } = info, recommendationRest = swcHelpers.objectWithoutProperties(info, [
        "sku",
        "tags"
    ]);
    const productTag = (tags === null || tags === void 0 ? void 0 : tags[0]) || getZeroDiscount(recommendation);
    return /*#__PURE__*/ React__default.createElement(ProductBlock, swcHelpers.extends({
        ref: ref,
        activeSku: sku
    }, recommendationRest, {
        /* We have to pass onVariantChange given it is not optional, even though
         * we know we will never have have variants on recommendations.
         */ /* eslint-disable-next-line @typescript-eslint/no-empty-function */ onVariantChange: ()=>{},
        /**
         * Some other props that are required but we don't need (yet).
         */ variants: [],
        isInsuranceReimbursable: false,
        /* Take the first tag as the product tag.
         * We currenlty dont have the percent based discount information in graphql to perform the propper fallback logic.
         */ tag: productTag
    }, rest));
});

export { ProductRecommendation };
//# sourceMappingURL=ProductRecommendation.js.map
